export default __webpack_public_path__ + "static/media/LabTests.2f6a7ee3.svg";